import { handleApiResponse } from '../../fetchUtils';

export const BEGIN_SUBMIT = 'BEGIN_SUBMIT'
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS'
export const SUBMIT_FAILURE = 'SUBMIT_FAILURE'
export const NO_CODE_SET = 'NO_CODE_SET'

function beginSubmit() {
  return { type: BEGIN_SUBMIT }
}

function submitSuccess() {
  return { type: SUBMIT_SUCCESS }
}

function submitFailure() {
  return { type: SUBMIT_FAILURE }
}

export function submitAuthorizationCode(code) {
  return dispatch => {
    dispatch(beginSubmit())
    return fetch(`/auth/google_oauth2/callback.json?code=${code}`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(response => handleApiResponse(response))
    .then(json => {
      if(json.unauthorized){ dispatch(submitFailure(json.unauthorized)) }
      else if(json.errors){ dispatch(submitFailure(json.errors.join("\n"))) }
      else if(json.redirect){ window.location = json.redirect }
      else { dispatch(submitSuccess()) }
    })
    .catch(error => dispatch(submitFailure(error.message)))
  }
}
